import { render, staticRenderFns } from "./lookup-confirmation.vue?vue&type=template&id=10f8510a&scoped=true"
import script from "./lookup-confirmation.vue?vue&type=script&lang=ts&setup=true"
export * from "./lookup-confirmation.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./lookup-confirmation.vue?vue&type=style&index=0&id=10f8510a&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f8510a",
  null
  
)

export default component.exports